module.exports = __webpack_public_path__ + "img/transparent_spring.525aab01.png";